let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kBEvL")).then(() => parcelRequire('dBfxW'));